import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Miami needed",
      "Ideal for NAS Jax and Mayport military families",
      "Perfect for JAXPORT cruise passengers",
      "Great for UNF students studying abroad",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Jacksonville post offices",
      "Good for planned international trips from JAX",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Duval County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Miami or Atlanta — no Jacksonville walk-in",
      "NPIC appointment required before traveling to Miami/Atlanta",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function JacksonvilleProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Jacksonville"
      introText="Jacksonville travelers — NAS Jax and Mayport military families, JAXPORT cruise passengers heading to the Bahamas, UNF students studying abroad, and business travelers flying out of JAX — have several options for getting a passport fast. Here is how they compare, and why most Northeast Florida residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive to Miami."
      options={options}
      emergencyDescription="Jacksonville does not have its own regional passport agency. The closest are Miami (~350 mi, 5+ hrs) and Atlanta (~350 mi, 5+ hrs). NAS Jax/Mayport military with deployment orders face 10+ hours round-trip. I-95 construction through Daytona and I-75 through South Georgia adds unpredictable delays. During hurricane season, I-10/I-95 evacuation traffic makes both routes impassable for hours."
      disclaimerText="*Processing speed depends on eligibility and documentation. Jacksonville does not have a regional passport agency — the closest are Miami and Atlanta. Not all applicants qualify for Regional Agency Processing."
    />
  );
}